{
  "settings": "Inställningar",
  "yourDigitalAssistant": "Din digitala assistent",
  "getStarted": "Starta",
  "login": "Login",
  "loggingIn": "Logga in ...",
  "darkMode": "Mörkt läge",
  "clearHistory": "Rensa historik",
  "historyCleared": "Historik rensad",
  "changeLanguage": "Språk",
  "termsAndConditions": "Allmänna villkor",
  "messagePlaceholder": "Skriv ditt meddelande här ...",
  "messagePlaceholderDisabled": "Typ avaktiverat ...",
  "feedbackTitle": "Betygsätt din upplevelse",
  "feedbackPlaceholder": "Berätta om det (valfritt)",
  "feedbackSend": "Skicka",
  "feedbackClose": "Stäng",
  "sessionExpired": "Din session har avslutats på grund av inaktivitet.",
  "startNewSession": "Starta en ny session",
  "apiError": "Oj! Något gick fel. Vi arbetar med att fixa detta så snart vi kan.",
  "apiErrorOffline": "Du är inte ansluten till internet.",
  "tryAgain": "Försök igen",
  "startOver": "Börja om",
  "chatEnded": "Chatten har avslutats.",
  "chatEndedThankYou": "Tack för att du chattar med oss!",
  "closeChat": "Stäng",
  "startNewChat": "Chatta igen",
  "humanTakeoverStarted": "Du överförs nu till kundservice ...",
  "humanTakeoverQueued": "Väntar på att bli ansluten till en agent",
  "humanTakeoverAnAgent": "En agent",
  "humanTakeoverAgentEntered": "gick in i konversationen",
  "humanTakeoverAgentLogout": "lämnade konversationen",
  "humanTakeoverTransfer": "Du överförs till en ny agent",
  "humanTakeoverEnded": "Du chattar nu med din digitala assistent",
  "version": "Version",
  "formIntroText": "Fyll i följande formulär för att börja chatta med oss.",
  "formFirstName": "Förnamn",
  "formLastName": "Efternamn",
  "formName": "Namn",
  "formEmail": "E-post",
  "formWrongEmail": "Ange en giltig e-postadress.",
  "formPhone": "Telefon",
  "formShipmentId": "Sändnings-ID",
  "formQuestion": "Din fråga",
  "formAccountNumber": "Kontonummer (för företagskunder)",
  "formAddress": "Adress",
  "formPostcode": "Postnummer",
  "formCity": "Stad",
  "formCountry": "Land",
  "formSubmitButton": "Börja chatta",
  "formEmptyFieldError": "Inte tillåtet att vara tomt.",
  "formPhoneNumberValidationError": "Inte ett giltigt telefonnummer.",
  "formInputIsBiggerThan50": "Måste vara högst 50 tecken.",
  "formInputIsBiggerThan100": "Måste vara högst 100 tecken.",
  "formInputIsBiggerThan2000": "Måste vara högst 2000 tecken.",
  "widgetEventOnline": "DA-meddelande: Användaren är tillbaka online.",
  "widgetEventHidden": "DA-meddelande: Widget är dold.",
  "widgetEventVisible": "DA-meddelande: Widget är synlig.",
  "widgetEventVisibleMinimized": "DA-meddelande: widgeten är synlig, men minimerad.",
  "widgetEventMinimized": "DA-meddelande: Widget minimeras.",
  "widgetEventMaximized": "DA-meddelande: Widget är maximerat.",
  "widgetEventSessionExpired": "DA-meddelande: Widget-session har gått ut.",
  "widgetEventHangupHuman": "DA -meddelande: Användare avslutar mänsklig övertagelsessession.",
  "widgetEventUserTyping": "DA-meddelande: användaren skriver.",
  "fileTooLarge": "Du försöker bifoga för stora filer.",
  "tooManyDiles": "Du försöker bifoga för många filer.",
  "fileInvalidType": "Du försöker bifoga ogiltiga filtyper.",
  "attachmentsDropHere": "Släpp här för att ladda upp eller",
  "attachmentsBrowse": "Bläddra bland filer",
  "attachmentsExtenstionQuantity": "pdf eller bilder (upp till 10 filer)",
  "attachmentsSize": "upp till 30 MB",
  "attachmentsFailedUploading": "Uppladdningen misslyckades",
  "attachmentsUploading": "Laddar upp ...",
  "minimizeExpandText": "Livechatt med oss nu!",
  "popupWidgetNotificationMessage": "Du har fått ett nytt meddelande!",
  "tabWidgetNotificationMessage": "Nytt meddelande!",
  "datepickerSendButton": "Skicka"
}
